import { render } from "./LoaderComp.vue?vue&type=template&id=c03c6e40&scoped=true"
import script from "./LoaderComp.vue?vue&type=script&lang=js"
export * from "./LoaderComp.vue?vue&type=script&lang=js"

import "./LoaderComp.vue?vue&type=style&index=0&id=c03c6e40&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c03c6e40"]])

export default __exports__